/**
 * Build-time brand strings. The values are baked in by the brandingPlugin
 * in vite.config.ts (driven by VITE_BRANDING). Use this for any
 * user-visible app-name text — title bars, install prompts, login copy —
 * so a single rebuild flips every surface for a new tenant.
 *
 * Defaults match the Sproutly profile so unbranded builds (e.g. local dev
 * without VITE_BRANDING) still resolve to readable strings.
 */
export const brand = {
  name: import.meta.env.VITE_BRAND_NAME || 'Sproutly',
  shortName: import.meta.env.VITE_BRAND_SHORT_NAME || 'Sproutly',
  description:
    import.meta.env.VITE_BRAND_DESCRIPTION || 'Sproutly — aftercare and childcare management.',
};
